import React from 'react'
import './stylesheet/index.scss'
import './utils/config/i18n'
import { Provider } from 'mobx-react'
import { stores } from './stores'
import { createRoot } from 'react-dom/client'
import { LoadScript } from '@react-google-maps/api'
import App from './scenes/App'
import configurations from './utils/config/configurations'

const rootElement = document.getElementById('root') as HTMLElement
const root = createRoot(rootElement)

root.render(
  <>
    <LoadScript
      libraries={['geometry', 'drawing', 'places']}
      googleMapsApiKey={configurations.GOOGLE_MAP_API_KEY}
    />

    <Provider store={stores}>
      <App />
    </Provider>
  </>
)
